import { AppIdentifier } from '@aipb/gulliver/env/model';
import { BaseEnvService } from '@aipb/gulliver/env/util';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { FrameService } from '@aipb/gulliver/frame/data-access';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';

export abstract class ApplicationInitGuard implements CanActivate {
  protected frame = inject(FrameService);

  protected constructor(protected app: AppIdentifier, protected env: BaseEnvService<any, any>) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setup(): void {}

  activate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(true);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const configId = 'configId' in route.params ? route.params['configId'] : 'default';

    this.env.setActiveConfigId(configId);
    this.frame.setConfigId(this.app, configId);
    this.frame.setup(this.app);

    this.setup();

    return this.activate(route, state);
  }
}
